// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/flaticon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/bold/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/duotone/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/fill/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/light/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/regular/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./fonts/thin/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!./css/style.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --splash-primary-color: #006EAB;
}

body {
  background-color: var(--psp-dark);
}

h4,
.text-fk-primary {
  color: var(--psp-primary) !important;
}

.form-control,
.form-select {
  border-radius: 10px;
  padding: 18px;
  font-size: 14px;
  line-height: 16px;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--psp-primary);
  /* &:invalid {
      border-color: var(--psp-accent);
  } */
}
.form-control[type=time],
.form-select[type=time] {
  padding-top: 16px;
  padding-bottom: 16px;
}

select:invalid {
  color: var(--splash-secondary-color) !important;
}

.form-check input:not(:disabled) {
  cursor: pointer;
}

.form-switch input[role=switch] {
  border-radius: 50px;
  width: 30px;
}

a,
.forgot-password-btn,
.link-btn {
  --splash-primary-color: var(--psp-dark);
}
a:hover,
.forgot-password-btn:hover,
.link-btn:hover {
  --splash-black-color: var(--psp-primary);
}

.default-btn,
.btn-check + label {
  font-family: var(--psp-button-font-family);
  background-color: var(--psp-primary) !important;
  text-transform: uppercase;
  color: #fff;
  border-radius: var(--psp-border-radius);
  border: var(--psp-border-width-btn) solid var(--psp-primary) !important;
  font-weight: 600;
  padding: 13px 30px;
}
.default-btn:hover,
.btn-check + label:hover {
  background-color: var(--psp-primary) !important;
  box-shadow: 0 0 25px -10px var(--psp-primary) !important;
}
.default-btn.secondary,
.btn-check + label.secondary {
  background-color: var(--psp-accent);
}
.default-btn.outlined,
.btn-check + label.outlined {
  background-color: #fff !important;
  color: var(--psp-dark) !important;
}
.default-btn:disabled,
.btn-check + label:disabled {
  opacity: 0.7;
}

.btn-check:not(:checked) + label {
  background-color: #fff !important;
  color: var(--psp-dark) !important;
  border-color: var(--psp-dark) !important;
}

/* button:not(.dropdown-item), .default-btn, *[tabindex] {
    &:focus {
        outline: 2px solid var(--splash-info-color) !important;
        outline-offset: .25rem;
        border-radius: var(--bs-border-radius-sm);
    }
} */
.shadow {
  box-shadow: 0px 4px 34px rgba(101, 96, 240, 0.1) !important;
}

/* QUILL-EDITOR */
.quill-editor {
  transition: border-color 0.15 ease-in-out !important;
  --border-color: #d1d5db;
  border-radius: 10px;
  border: 1px solid var(--border-color);
}
.quill-editor[disabled=true] {
  background-color: var(--bs-secondary-bg);
}
.quill-editor .ql-toolbar.ql-snow {
  border: none;
  border-bottom: 1px solid var(--border-color);
}
.quill-editor .ql-container.ql-snow {
  border: none;
  max-height: 150px;
  overflow: auto;
}
.quill-editor .ql-container.ql-snow .ql-editor {
  padding: 18px;
}
.quill-editor .ql-container.ql-snow[disabled=true] {
  background-color: var(--bs-secondary-bg);
}

.dark .quill-editor {
  background-color: var(--splash-black-color);
  --border-color: #45445e;
}

.therapy-calendar {
  width: 100%;
  border: none !important;
}
.therapy-calendar .vc-blue {
  --vc-accent-50: #f0f9ff;
  --vc-accent-100: #e0f2fe;
  --vc-accent-200: #bae6fd;
  --vc-accent-300: #7dd3fc;
  --vc-accent-400: #38bdf8;
  --vc-accent-500: var(--psp-primary);
  --vc-accent-600: #0284c7;
  --vc-accent-700: #0369a1;
  --vc-accent-800: #075985;
  --vc-accent-900: #0c4a6e;
}

.text-badge.text-primary {
  background: #f2f1f9;
}

.text-badge.text-warning {
  background: #fff9ec;
}

.recent-activity-box .list li.success-step .icon {
  color: var(--splash-success-color);
  border-color: var(--splash-success-color);
}

.recent-activity-box .list li.danger-step .icon {
  color: var(--splash-danger-color);
  border-color: var(--splash-danger-color);
}

.alert:not(.show) {
  pointer-events: none;
}

.patient-survey-card .card-body .accordion .accordion-item .accordion-body {
  padding: 0;
}
.patient-survey-card .card-body .accordion .accordion-item .accordion-body ul li:last-child {
  border: none;
}

table tbody tr:last-child th,
table tbody tr:last-child td {
  border: none;
}

table tbody.linked {
  cursor: pointer;
}
table tbody.linked tr td, table tbody.linked tr th {
  transition: 0.3s !important;
}
table tbody.linked tr:hover td, table tbody.linked tr:hover th {
  background-color: rgba(0, 110, 171, 0.0392156863);
}

.version-list > div:last-child {
  border: none !important;
}

a[disabled=true] {
  cursor: initial;
}
a[disabled=true]:hover {
  color: unset;
}

.pointer-event-none {
  pointer-events: none;
}

/* ADMIN THEME */
body.admin {
  background: linear-gradient(314deg, #e9acac 0%, #dee7f8 60%);
}

.min-h-75 {
  min-height: 75px;
}

/* CALENDAR */
.calendar-card .fc .fc-h-event {
  padding: 0 5px !important;
  border-radius: var(--bs-border-radius) !important;
}

.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  font-weight: bold;
}

/* ACCORDION */
.accordion .accordion-item .accordion-body ul li {
  padding: unset;
  border: unset;
}

.accordion[id^=surveys-] .accordion-item .accordion-body ul li {
  border-bottom: 1px dashed #D2CFE4;
  padding: 20px;
}

.search-box .form-control {
  background-color: var(--bs-tertiary-bg) !important;
}

.spinner-border-xs {
  --bs-spinner-width: 14px;
  --bs-spinner-height: 14px;
}

.f-en {
  background-position: 0 -3444px;
}

.modal-body {
  max-height: 70vh;
  overflow-y: scroll;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content, .container.h-100vh, #app .wrapper {
  /* min-height: calc(100vh - 71px) !important;
  height: unset !important; */
  flex-grow: 1;
  min-height: unset !important;
}

.form-check .form-check-label a {
  font-weight: bold !important;
}

.password-input {
  position: relative;
}
.password-input input:has(+ i) {
  padding-right: 54px;
}
.password-input input:has(+ i).is-invalid {
  background-image: none;
}
.password-input input:has(+ i).is-invalid + i {
  color: var(--bs-form-invalid-border-color) !important;
}
.password-input input + i {
  padding: 18px;
  cursor: pointer;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
